import { useTranslation } from 'react-i18next'
import { Flex, useSporeColors } from 'ui/src'
import { Sign } from 'ui/src/components/icons/Sign'
import { StepRowProps, StepRowSkeleton } from 'uniswap/src/components/ConfirmSwapModal/steps/StepRowSkeleton'
import { StepStatus } from 'uniswap/src/components/ConfirmSwapModal/types'
import { Permit2SignatureStep } from 'uniswap/src/features/transactions/swap/types/steps'

const SignIcon = (): JSX.Element => (
  <Flex centered width="$spacing24" height="$spacing24" borderRadius="$roundedFull" backgroundColor="$surface2">
    <Sign color="$neutral2" size="$icon.12" />
  </Flex>
)

export function Permit2SignatureStepRow({ step, status }: StepRowProps<Permit2SignatureStep>): JSX.Element {
  const { t } = useTranslation()

  return (
    <StepRowSkeleton
      status={status}
      icon={<SignIcon />}
      title={t('swap.permit.signature.title')}
    />
  )
}